import React from 'react';

import iconWriteEmail from '../../images/icon-write-email.svg';
import iconTwitterAlt from '../../images/icon-twitter-alt.svg';
import iconFacebookAlt from '../../images/icon-facebook-alt.svg';
import iconInstagramAlt from '../../images/icon-instagram-alt.svg';
import {
  LINEAGE_TEAM_SOCIAL_URLS,
  resolveTeamEmail,
  resolveTeamSocialUrl,
} from '../../constants/team-social';

const TEAM_SOCIAL_ITEMS = [
  { key: 'facebook', icon: iconFacebookAlt, alt: 'Facebook' },
  { key: 'instagram', icon: iconInstagramAlt, alt: 'Instagram' },
  { key: 'twitter', icon: iconTwitterAlt, alt: 'Twitter' },
  { key: 'email', icon: iconWriteEmail, alt: 'Email' },
];

export default function TeamMemberFooterLinks({ facebook, instagram, twitter, email }) {
  const values = { facebook, instagram, twitter, email };

  return (
    <div className="social-share">
      <ul>
        {TEAM_SOCIAL_ITEMS.map(({ key, icon, alt }) => {
          if (key === 'email') {
            const mail = resolveTeamEmail(values.email);
            return (
              <li key={key}>
                <a href={`mailto:${mail}`}>
                  <img src={icon} alt={alt} />
                </a>
              </li>
            );
          }

          const href = resolveTeamSocialUrl(values[key], LINEAGE_TEAM_SOCIAL_URLS[key]);

          return (
            <li key={key}>
              <a href={href} target="_blank" rel="noopener noreferrer">
                <img src={icon} alt={alt} />
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
